// Helpers para serializar tipos Mongo (Extended JSON)

export function oid(id) {
  if (!id) return null
  
  return { $oid: id }
}

export function date(value) {
  if (!value) return null

  if (value instanceof Date) {
    return { $date: value.toISOString() }
  }

  return { $date: new Date(value).toISOString() }
}